import type { TaskSubject, TaskSubjectEntity } from "@asap/shared/schemas/task/context";
import { z } from "zod";

const uuidSchema = z.string().uuid();

const ROUTE_ENTITY_PREFIXES: { prefix: string; entity: TaskSubjectEntity }[] = [
  { prefix: "/talents/", entity: "talents" },
  { prefix: "/companies/", entity: "companies" },
  { prefix: "/missions/", entity: "missions" },
  { prefix: "/contracts/", entity: "contracts" },
  { prefix: "/contacts/", entity: "contacts" },
];

const parseUuid = (value: string): string | null => {
  const parsed = uuidSchema.safeParse(value);
  if (!parsed.success) {
    return null;
  }
  return parsed.data;
};

export const getTaskSubjectFromRoute = (route: { path: string }): TaskSubject | null => {
  for (const { prefix, entity } of ROUTE_ENTITY_PREFIXES) {
    if (!route.path.startsWith(prefix)) {
      continue;
    }

    const rest = route.path.slice(prefix.length);
    const firstSegment = rest.split("/").find((segment) => segment.length > 0);
    const entityId = firstSegment ? parseUuid(firstSegment) : null;
    if (!entityId) {
      return null;
    }

    return {
      entity,
      entity_id: entityId,
    };
  }

  return null;
};
